// // import React, { ReactNode, useEffect, useState } from "react";
// // import { Navigate } from "react-router-dom";
// // import { useAuth } from "../context/AuthContext";
// // import { tokenStore } from "../services/tokenStore";

// // export default function PrivateRoute({
// //   children,
// //   requiredRoleKeys,
// // }: {
// //   children: ReactNode;
// //   requiredRoleKeys?: string[];
// // }) {
// //   const { bootstrapFromStoredToken, roleKeys } = useAuth();
// //   const stored = tokenStore.get();
// //   const [ready, setReady] = useState(false);

// //   useEffect(() => {
// //     (async () => {
// //       try {
// //         await bootstrapFromStoredToken();
// //       } finally {
// //         setReady(true);
// //       }
// //     })();
// //   }, []);

// //   if (!stored?.accessToken) return <Navigate to="/" replace />;
// //   if (!ready) return <div style={{ padding: 30 }}>Loading...</div>;

// //   if (requiredRoleKeys?.length) {
// //     const ok = requiredRoleKeys.some((rk) => roleKeys.includes(rk.toLowerCase()));
// //     if (!ok) return <Navigate to="/unauthorized" replace />;
// //   }

// //   return <>{children}</>;
// // }
// import React, { ReactNode } from "react";
// import { Navigate } from "react-router-dom";
// import { useAuth } from "../context/AuthContext";

// type Props = {
//   children: ReactNode;
//   requiredRoleKeys?: string[];
// };

// export default function PrivateRoute({ children, requiredRoleKeys }: Props) {
//   const { doctor, tokens } = useAuth();

//   // Not logged in
//   if (!doctor || !tokens?.accessToken) {
//     return <Navigate to="/" replace />;
//   }

//   // Role enforcement
//   if (requiredRoleKeys?.length) {
//     const roleKeys =
//       doctor?.roleAssignments
//         ?.filter((r: any) => r.status === "ACTIVE")
//         ?.map((r: any) => r.role?.key) || [];

//     const allowed = roleKeys.some((k: string) =>
//       requiredRoleKeys.includes(k)
//     );

//     if (!allowed) {
//       return <Navigate to="/unauthorized" replace />;
//     }
//   }

//   return <>{children}</>;
// }

import React, { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

type Props = {
  children: ReactNode;
  requiredRoleKeys?: string[];
};

export default function PrivateRoute({ children, requiredRoleKeys }: Props) {
  const { doctor, tokens } = useAuth();

  // 🔒 Not logged in
  if (!doctor || !tokens?.accessToken) {
    return <Navigate to="/" replace />;
  }

  // 🧠 Get ACTIVE role keys
  const activeRoleKeys =
    doctor.roleAssignments
      ?.filter((r: any) => r.status === "ACTIVE")
      ?.map((r: any) => r.role?.key?.toLowerCase())
      ?.filter(Boolean) || [];

  // ❌ Logged in but NO role assigned
  if (activeRoleKeys.length === 0) {
    return <Navigate to="/no-role" replace />;
  }

  // 🔐 Role-based access
  if (requiredRoleKeys?.length) {
    const allowed = requiredRoleKeys.some((rk) =>
      activeRoleKeys.includes(rk.toLowerCase()),
    );

    if (!allowed) {
      return <Navigate to="/unauthorized" replace />;
    }
  }

  return <>{children}</>;
}
